import classNames from 'classnames';
import {
  FormikTextFieldLegacy,
  type FormikTextFieldLegacyProps,
} from 'components/FormikTextFieldLegacy/FormikTextFieldLegacy';
import { type JSX, useState } from 'react';
import './styles.css';
import {
  type FilterTextValueType,
  numberComparators,
  stringComparators,
} from './comparator';

interface Props<TFormikValues>
  extends FormikTextFieldLegacyProps<TFormikValues> {
  type: FilterTextValueType;
}

const comparators = {
  number: numberComparators,
  string: stringComparators,
};

export const FormikFilterTextField = <TFormikValues,>({
  type,
  ...props
}: Props<TFormikValues>): JSX.Element => {
  const [focused, setFocused] = useState<boolean>(false);

  const handleFocus = () => {
    setFocused(true);
  };

  const handleBlur = () => {
    setFocused(false);
  };

  return (
    <div className='formik-filter-text-field'>
      <div
        className={classNames(
          'formik-filter-text-field__tooltip',
          focused && 'formik-filter-text-field__tooltip--visible',
          'px-lgu-2',
        )}
      >
        <i className='fa-regular fa-lightbulb mr-lgu-3' />
        {comparators[type].map((comparator) => (
          <div
            key={comparator}
            className='formik-filter-text-field__comparator'
          >
            {comparator}
          </div>
        ))}
      </div>
      <FormikTextFieldLegacy
        {...props}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
    </div>
  );
};
